module.exports = __webpack_public_path__ + "static/media/mace.845780d1.svg";